export enum PRACTITIONER_STATUS {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export const enum CALENDAR_STATUS {
  UNAVAILABLE = "unavailable",
  HOLIDAY = "holiday",
}

export enum DOCUMENT_TYPES {
  IMAGES = "image/*",
  DOCUMENTS = "application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf,",
}
